// extracted by mini-css-extract-plugin
export default {"navSocials":"styles_navSocials__ZlcFe","navLinks":"styles_navLinks__Wp2f5","icon":"styles_icon__Ur1TW","dev":"styles_dev__+wIQq","logo":"styles_logo__YpvBc"};